import { createFileRoute } from '@tanstack/react-router'
import type { JSX } from 'react'

export const Route = createFileRoute('/_app/account')({
  component: AccountPage,
})

function AccountPage(): JSX.Element {
  return <div>Mi cuenta — placeholder</div>
}
